import { Navigate } from 'react-router-dom';
export function AuthCompletePage() { return <Navigate to="/" replace />; }
